module.exports = __webpack_public_path__ + "static/media/usedpanda.3af3a09e.png";